import { createFileRoute, redirect } from "@tanstack/react-router";

// The eight regional pages are folded into the one "probate anywhere in Queensland" page.
export const Route = createFileRoute("/remote-probate/$region")({
  beforeLoad: () => {
    throw redirect({ href: "/remote-probate", statusCode: 301 });
  },
});
